
export const searchWord = (keyword, itemlist) => {
   
    var reg = new RegExp(keyword.toLowerCase());
    let substr = keyword.slice(0, 3).toLowerCase();
    var subReg = new RegExp(substr);
    let results = itemlist.filter((term) => {

        let wordStr = term?.designation?.toLowerCase();
        let brandString = term?.brand?.toLowerCase();
        if (!keyword.length) return null;
        return (wordStr.match(reg) || wordStr.match(subReg) || brandString.match(reg) || brandString.match(subReg)) ? term : null;
    });

    return results;
}